import * as React from 'react';
import {
    DetailsList,
    SelectionMode,
    ConstrainMode,
    IColumn,
} from 'office-ui-fabric-react/lib/DetailsList';
import { observer } from 'mobx-react';

export interface DiagnosticsTableProps {
    header: { [field: string]: string };
    datapoints: any[];
}

@observer
export default class DiagnosticsTable extends React.Component<DiagnosticsTableProps, {}> {
    render() {
        let columns: IColumn[];
        if (this.props.header) {
            columns = [];

            for (let field of Object.keys(this.props.header)) {
                columns.push({
                    key: field,
                    minWidth: 0,
                    name: this.props.header[field],
                    fieldName: field,
                });
            }
        }

        return (
            <DetailsList
                items={this.props.datapoints}
                columns={columns}
                selectionMode={SelectionMode.none}
                constrainMode={ConstrainMode.unconstrained}
                onRenderItemColumn={(item, index, column) => {
                    return <span>{item[column.key]}</span>;
                }}
            />
        );
    }
}
